'use strict';

import { createLabel, latLngAltToVector3, Layer } from './Layer';
import { BufferGeometry, Line, LineBasicMaterial, Vector3 } from 'three';

export class Education extends Layer {

    constructor (parent, data) {
        super(parent, data);

        this.createLayer();
    }

    async createLayer() {

        this.data = await this.response;

        if (!this.data) {
            this.btn?.remove();
            return;
        }

        const center = {lat: Number(config.localization.latitude), lng: Number(config.localization.longitude)};
        const lineMaterial = new LineBasicMaterial({color: '#ffffff', transparent: true});
        const tempVector = new Vector3();
        const intersectedVector = new Vector3();

        this.data.forEach((obj,index) => {
            const names = {};
            const amenity = obj.tags.amenity;

            config.languages.forEach(lang => {
                if (obj.tags.hasOwnProperty(`name:${lang}`)) {
                    names[lang] = obj.tags[`name:${lang}`];
                } else if (obj.tags.hasOwnProperty('name')) {
                    names[lang] = config.dictionary[obj.tags.name] ? config.dictionary[obj.tags.name][lang] : obj.tags.name;
                } else {
                    const dKey = amenity.charAt(0).toUpperCase() + amenity.slice(1).replace('_',' ');
                    names[lang] = config.dictionary[dKey] ? config.dictionary[dKey][lang] : dKey;
                }
            });

            let point;

            switch (obj.type) {
                case 'node':
                    point = {lat: obj.lat, lng: obj.lon};
                    break;
                case 'way':
                    point = {lat: obj.center.lat, lng: obj.center.lon};
                    break;

            }

            let icon;
            let color;

            const pointOfInterest = this.layer.pointsOfInterest[amenity];

            if (pointOfInterest) {
                color = pointOfInterest.color ? pointOfInterest.color : '#bfbfbf';
                icon = pointOfInterest.icon ? pointOfInterest.icon : amenity.charAt(0).toUpperCase();
            } else {
                color = '#bfbfbf';
                icon = amenity.charAt(0).toUpperCase();
            }

            const vector = latLngAltToVector3(point,center);
            intersectedVector.copy(vector);
            intersectedVector.applyQuaternion(this.routeGroup.quaternion);
            intersectedVector.add(this.routeGroup.position);
            const altitude = this.intersectHeightFromVector3(intersectedVector);
            const distance = Math.floor(new Vector3().distanceTo(vector));
            vector.y = altitude + distance / 5;

            const label = createLabel(names,icon,color,distance);
            label.position.copy(vector);
            tempVector.copy(vector);
            tempVector.y = -500;
            const lineGeometry = new BufferGeometry().setFromPoints([
                tempVector,
                vector
            ]);
            const line = new Line(lineGeometry,lineMaterial);
            line.name = 'poi_line';

            const poiData = {
                id: index,
                to: point,
                from: center,
                route: null
            };

            label.element.onclick = () => this.poiHandler(poiData);
            
            this.labels.push({
                line,
                label,
                distance
            });

            this.routeGroup.add(label,line);
            // poiHeight += poiHeightStep;
        });

    }

}
